import { DefaultValues, FieldValues, useForm, UseFormReturn } from 'react-hook-form';

export default function useNeveForm<T extends FieldValues>(
    defaultValues?: DefaultValues<T> | undefined,
): UseFormReturn<T, any> {
    const useFormReturn = useForm<T>({ mode: 'onBlur', defaultValues: defaultValues });
    return useFormReturn;
}
